<div fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row">
    <h2>Dodaj plik</h2>
  </div>

  <div fxLayout="row" fxLayoutAlign="center">
    <app-file-drag-and-drop fxFlex="100" [multiple]="true" [fileControl]="fileControl" [required]="true" [maxSize]="maxSize"  (fileSizeMore)="expirationOptionsUnlock($event)"  [fileResults]="fileResults" [resetFilesOnAdd]="false"></app-file-drag-and-drop>
  </div>

  <div fxLayout="row">
    <mat-form-field fxFlex="100" >
      <mat-label> Nazwa </mat-label>
      <input [required]="true" name="name"  matInput placeholder="Nazwa"   [formControl]="nameControl" >
      <mat-error *ngIf="nameControl.hasError('required')">
        To pole jest wymagane
      </mat-error>
    </mat-form-field>
  </div>

  <div fxLayout="row">
    <mat-form-field fxFlex="100" >
      <mat-label> Hasło </mat-label>
      <input [required]="false" name="password"  matInput placeholder="Hasło"   [formControl]="passwordControl" >
      <mat-error *ngIf="passwordControl.hasError('required')">
        To pole jest wymagane
      </mat-error>

      <mat-error *ngIf="passwordControl.hasError('minlength')">
        Hasło musi mieć co najmniej 8 znaków
      </mat-error>

      <mat-error *ngIf="passwordControl.hasError('pattern')">
        Hasło musi zawierać przynajmniej 1 dużą literę oraz 1 cyfrę
      </mat-error>      <mat-error></mat-error>
    </mat-form-field>
  </div>

  <div fxLayout="row">
  <mat-form-field  style="width: 100%; display: inline-block;">
    <mat-select [required]="true" [formControl]="expirationDaysControl" [placeholder]="'Ważność pliku'">
      <mat-option *ngFor="let option of expirationOptions" [value]="option.value">
        {{ option.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>

    <button  mat-raised-button (click)="sendForm()" color="primary" [class.spinner]="processingRequest" [disabled]="processingRequest">Zapisz</button>
    <button (click)="closeDialog($event)" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
